<template>
  <div>
		<div class="mt-5 pt-4">
      <nav class="mb-5" style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='black'/%3E%3C/svg%3E&#34;);" aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item" style="font-size:24px; line-height: 24px; font-weight:900; color:#435666;"><strong>Settings</strong></li>
          <li class="breadcrumb-item active" aria-current="page" style="font-size:24px; line-height: 24px; font-weight:300; color:#435666;">Scheduled Jobs</li>
        </ol>
      </nav>

			<div class="mt-4">
				<div class="row">
					<div class="col-md-12">
						<div class="card shadow p-3 mb-5 bg-white rounded border-0">
							<div class="card-body table-responsive">
                <table class="table">
                  <thead>
                    <tr class="table-light">
                      <th>Scheduled Job</th>
                      <th><span style="cursor: pointer;" @click="sortList">Schedule</span>
                        <span v-if="pagination.sortBy.value == 'ascending'" class="text-small ms-2"><i class="fas fa-long-arrow-alt-up"></i></span>
                        <span v-if="pagination.sortBy.value == 'descending'" class="text-small ms-2"><i class="fas fa-long-arrow-alt-down"></i></span>
                      </th>
                      <th>Auto Run</th>
                      <th>Manual Run</th>
                      <th>Log</th>
                      <th>Last Run Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                    <tbody class="align-middle" v-for="(item, index) in sortedJobs" :key="index">
                      <tr>
                          <td>{{ item.scheduled_job.name }}</td>
                          <td>{{ item.schedule  }} </td>
                          <td>
                            <label class="form-check form-switch custom-slider" v-tooltip.top="item.scheduled_job.is_active ? 'Disable Cron' : 'Enable Cron'">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                role="switch"
                                v-model="item.scheduled_job.is_active"
                                @change="updateJobStatus(item.scheduled_job)">
                              <span class="slider"><span class="slider-button"></span></span>
                            </label>
                          </td>
                          <td>
                            <button type="button" class="btn btn-default btn-circle ms-1" @click="onRunAll(item)" :disabled="loading" v-tooltip.top="'Run for All Organisations'">
                              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
                              <i v-if="!loading" class="fa fa-play"></i>
                            </button>
                            <button type="button" class="btn btn-default btn-circle ms-1" @click="showOrgList(item)" v-if="item.scheduled_job.name != 'Unlock Scheduled Job'" v-tooltip.top="'Run for a Selected Organisation'"><i class="fa fa-play-circle"></i></button>
                          </td>
                            <td>
                              <button type="button" class="btn btn-default btn-circle btn-log" data-bs-toggle="collapse" :data-bs-target="'#logs' + index" :aria-expanded="item.expand" aria-controls="logs" @click="navItemCollapse(index)" v-tooltip.top="item.expand ? 'Close Log History' : 'Show Log History'">
                                <i class="fas fa-list-ul log-collapsed"></i>
                                <i class="fas fa-arrow-circle-down log-expanded"></i>
                              </button>
                            </td>
                          <td :class="item.last_run_status.toLowerCase() == 'success' ? 'text-success' : 'text-danger'">{{ item.last_run_status }}</td>
                          <td>
                            <button type="button" class="btn btn-default btn-circle" ms-1 @click="showSchedule(item)" v-tooltip.top="'Add a New or Edit an Existing Schedule'"><i class="fas fa-cog"></i></button>
                          </td>
                      </tr>
                      <tr class="collapse collapse-vertical"  :class="{show: item.expand}" style="transition: opacity ease-in-out;">
                        <td colspan="4" class="table-responsive">
                          <table class="table expand">
                            <tbody v-if="!logsLoading">
                              <th>
                                <td>Date Time</td>
                              </th>
                              <th>
                                <td>Status</td>
                              </th>
                              <th>
                                <td>Error Message</td>
                              </th>
                              <th>
                                <td>Organisation</td>
                              </th>
                              <th>
                                <td>Auto Run</td>
                              </th>
                              <th>
                                <td>Organisation List</td>
                              </th>
                              <th>
                                <td># of Org</td>
                              </th>
                              <tr v-for="(item, index) in logs" :key="index">
                                <td>{{ runTime(item) }}</td>
                                <td>{{ item.status }}</td>
                                <td>{{ item.description }}</td>
                                <td>{{ item.organisation }}</td>
                                <td>{{ item.is_auto_run ? "Yes" : "No" }}</td>
                                <td>
                                  <a v-if="item.total_org_run > 0 && item.organisation === 'All'"
                                    @click="setOrgCronList(item.organisation_info)"
                                    v-tooltip.top="'Click to show Organisations'"
                                    style="color: #00A0C1; cursor: pointer; text-decoration: none;">
                                    Click for more details.
                                  </a>
                                  <span v-else style="color: #AAA; cursor: not-allowed; text-decoration: none;">
                                    Click for more details.
                                  </span>
                                </td>
                                <td>{{ item.total_org_run}}</td>
                              </tr>
                              <tr>
                                <td colspan="4">
                                  <div class="d-flex align-items-center justify-content-end text-default">
                                    <div style="display: flex; align-items: center;">
                                      <span style="margin-right: 8px;">Rows per page:</span>

                                      <select
                                        class="form-select form-select-sm shadow-none rounded-0"
                                        v-model="this.pagination.rowsPerPage"
                                        style="width: 100px;"
                                      >
                                      <option class="dropdown-item" v-for="(item, index) in rowsOptions" :key="index" >
                                        {{item}}
                                      </option>
                                      </select>
                                    </div>

                                    <div style="padding-right: 16px; padding-left: 16px; font-size:14px;">
                                      <span> {{ paginationLabel }} of {{ this.pagination.total }} </span>
                                    </div>
                                    <div>
                                      <a
                                        @click="prev(item)"
                                        style="font-size: 14px; margin-right: 8px;"
                                        :style="currPage == 1 ? 'color: #ccc;' : 'cursor: pointer;'"
                                        :disabled="currPage == 1"
                                      >
                                        <i class="fa fa-chevron-left" aria-hidden="true"></i>
                                      </a>

                                      <a
                                        @click="next(item)"
                                        style="font-size: 14px; margin-left: 8px;"
                                        :style="logs.length < pagination.rowsPerPage ? 'color: #ccc;' : 'cursor: pointer;'"
                                        :disabled="logs.length < pagination.rowsPerPage"
                                      >
                                        <i class="fa fa-chevron-right" aria-hidden="true"></i>
                                      </a>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                            <tbody v-else>
                              <div class="text-center">
                                <div class="spinner-border" role="status">
                                </div>
                              </div>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                </table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

    <vue-final-modal v-model="runDialog" classes="modal-container" content-class="modal-content">
      <div class="modal-header justify-content-between">
        <span class="modal__title text-white">{{ selectedItem == null ? '' : this.selectedItem.scheduled_job.name  }}</span>
        <div>
          <button type="button" class="btn-close" aria-label="Close" @click="closeOrgList()"></button>
        </div>
      </div>
      <div class="modal__body">
        <div class="modal__content mt-3 mb-4">
          <vue-select :options="organisations" clear-on-close label-by="name" value-by="id" v-model="selectedOrg" close-on-select :visible-options="filteredOrgs" searchable @search:input="filterOrgs(event)" />
        </div>
        <div class="modal__action">
          <button class="btn btn-outline-primary" type="button" :disabled="loading"  @click="onRun">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
            {{this.loading ? 'Running' : 'Run'}}
          </button>
        </div>
      </div>
    </vue-final-modal>

    <vue-final-modal v-model="orgListDialog" classes="modal-container" content-class="modal-content">
      <div class="modal-header justify-content-between">
        <span class="modal__title text-white">Successfully Ran Organisations</span>
        <div>
          <button type="button" class="btn-close" aria-label="Close" @click="closeOrgCronList()"></button>
        </div>
      </div>
      <div class="modal__body">
        <div class="modal__content mt-3 mb-4" style="max-height: 75vh; overflow-y: auto;">
          <ul style="list-style-type: none;">
            <li v-for="(item, index) in cronOrgList" :key="index">{{ item }}</li>
          </ul>
        </div>
      </div>
    </vue-final-modal>

    <!-- Schedule Modal -->
    <vue-final-modal v-model="scheduleDialog" classes="modal-container" content-class="modal-content-schedule">
      <div class="modal-header justify-content-between">
        <span class="modal__title text-white">{{ selectedItem == null ? '' : this.selectedItem.scheduled_job.name }} <span class="text-white">- Schedule Settings</span></span>
        <div>
          <button type="button" class="btn-close" aria-label="Close" @click="(scheduleDialog = false)"></button>
        </div>
      </div>

      <div class="modal__body">
        <div class="modal__content-schedule mt-3 mb-4">
          <div class="row">
            <div class="col-lg-6">
              <label class="form-label" for="frequency">Frequency</label>
              <select class="form-select form-select-md" id="frequency" aria-label=".form-select-md" v-model="schedule.frequency" required>
                <option v-for="item in frequencies" :key="item.value" :value="item.value">{{item.label}}</option>
              </select>
              <div class="text-danger" v-for="error of v$.schedule.frequency.$errors" :key="error.$uid">
                <div class="form-text text-danger">{{ error.$message }}</div>
              </div>
            </div>
            <div class="col-6 mb-3">
              <label class="form-label" for="time">Time</label>
              <Datepicker v-model="schedule.time" id="time" timePicker/>
              <div class="text-danger" v-for="error of v$.schedule.time.$errors" :key="error.$uid">
                <div class="form-text text-danger">{{ error.$message }}</div>
              </div>
            </div>

            <div class="col-6 mb-3">
              <label class="form-label" for="email">Email address</label>
              <input type="email" v-model="schedule.email" class="form-control" id="email" placeholder="vtxsecurity@gmail.com">
              <div class="text-danger" v-for="error of v$.schedule.email.$errors" :key="error.$uid">
                <div class="form-text text-danger">{{ error.$message }}</div>
              </div>
            </div>
          </div>
            <!-- checkbox -->
            <div class="row">
              <div class="col-12">
                <input class="form-check-input" type="checkbox" id="success" v-model="schedule.successAlerts">
                <label class="form-check-label mx-2" for="success">
                    Success Alerts
                </label>
              </div>
              <div class="col-12 mb-5">
                <input class="form-check-input" type="checkbox" id="fail" v-model="schedule.failAlerts">
                <label class="form-check-label mx-2" for="fail">
                    Fail Alerts
                </label>
              </div>
            </div>
            <!-- buttons -->
            <div class="col-12 mb-5">
              <div class="text-center p-1">
                <button type="button" class="btn btn-outline-primary ms-3 col-10" style="padding-right:19px" @click="saveSchedule" >{{ saveButton }}</button>
              </div>
              <div class="text-center p-1">
                <button type="button" class="btn btn-outline-clear ms-3 col-10" @click="clearSchedule">Clear</button>
              </div>
            </div>

            <div class="col-12">
              <table class="table expand">
                <tbody v-if="!loading">
                  <th>
                    <td>Frequency</td>
                  </th>
                  <th>
                    <td>Time</td>
                  </th>
                  <th>
                    <td>Email</td>
                  </th>
                  <th>
                    <td>Success Alerts</td>
                  </th>
                  <th>
                    <td>Fail Alerts</td>
                  </th>
                  <th>
                    <td>Actions</td>
                  </th>
                  <tr v-for="(item, index) in schedules" :key="index">
                    <td>{{ item.frequency }}</td>
                    <td>{{ utcToLocal(item.time)}}</td>
                    <td>{{ item.email }}</td>
                    <td>{{ item.success_alerts ? "Yes" : "No" }}</td>
                    <td>{{ item.fail_alerts ? "Yes" : "No" }}</td>
                    <td>
                        <button type="button" class="btn btn-default btn-circle ms-1" @click="editSchedule(item)"><i class="fas fa-edit"></i></button>
                        <button type="button" class="btn btn-default btn-circle-danger ms-1" @click="deleteSchedule(item)"><i class="fas fa-trash"></i></button>
                    </td>
                  </tr>
                  <tr v-if="schedules.length == 0">
                    <td colspan="6">
                      <div class="card shadow bg-white rounded border-0">
                        <div class="card-body">
                          <h5 class="text-center">Empty</h5>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <div class="text-center">
                    <div class="spinner-border" role="status">
                    </div>
                  </div>
                </tbody>
              </table>
            </div>

        </div>
      </div>
    </vue-final-modal>
	</div>
</template>

<script>
import { ref } from 'vue';
import moment from 'moment';
import { useVuelidate } from '@vuelidate/core'
import { required, email } from '@vuelidate/validators'

export default {
  name: "ScheduledJobs",

  setup() {
    const time = ref({
        hours: new Date().getHours(),
        minutes: new Date().getMinutes()
    });

    return {
      time,
      v$: useVuelidate(),
    }
  },

  validations () {
    return {
      schedule: {
        frequency: {required},
        time: {required},
        email: {required, email},
      },
    }
  },

  data() {
    return {
      loading:false,
      selectedItem: null,
      selectedOrg: null,
      organisations: this.$store.state.user.organisations,
      saveButton: 'Save',
      search: "",
      runDialog: false,
      scheduleDialog: false,
      filteredOrgs: this.$store.state.user.organisations,

      logs: [],
      logsExpanded: false,
      jobs:[],
      expandedLog: {},
      expandedIndex: -1,

      schedules: [],
      schedule: {
        id: null,
        frequency: '',
        time: this.time,
        email: '',
        successAlerts: false,
        failAlerts: false
      },

      pagination:{
        page: 1,
        rowsPerPage: 10,
        total: 2,
        sortBy: {
          'name': 'Schedule',
          'value': 'ascending'
        }
      },
      rowsOptions: [5,10,15],
      logsLoading: false,

      //added hourly value to cron
      frequencies: [
        {
          value: "hourly",
          label: "Hourly"
        },
        {
          value: "daily",
          label: "Daily"
        },
        {
          value: "weekly",
          label: "Weekly - Sunday"
        },
        {
          value: "monthly",
          label: "Monthly - 1st of month"
        }
      ],
      cronOrgList: null,
      orgListDialog: false
    }
  },

  async created() {
      await this.getData();
  },

  methods: {
    getData() {
      this.$axios.get('/supadmin/scheduled-jobs')
      .then((response) => {
          if (response.data.success){
            this.jobs = response.data.scheduled_jobs;
              for (let i = 0; i < this.jobs.length; i++) {
                this.jobs[i]["expand"] = false
                //format time and frequency and for display
                let scheduleConcat = ""
                for (const jobSched of this.jobs[i].scheduled_job.job_schedule) {
                    let schedule = jobSched.frequency + " - " + this.utcToLocal(jobSched.time)
                    scheduleConcat = scheduleConcat + schedule + " | "
                }
                this.jobs[i]["schedule"] = scheduleConcat
              }
          } else {
              this.$toast.error(response.data.message)
          }
      })
      .catch()
    },


    closeOrgCronList() {
      this.orgListDialog = false;
      this.cronOrgList = null;
    },

    setOrgCronList(item) {
      this.orgListDialog = true;
      const originalList = item; // 'item' contains the original list as a string

      // Split the list by commas and store it in cronOrgList
      this.cronOrgList = originalList.split(',');
    },

    updateJobStatus(job) {
      const newStatus = job.is_active;
      this.$axios.put(`/supadmin/scheduled-jobs/${job.ID}/status`, {
        is_active: newStatus
      })
      .then(response => {
        if (response.data.success) {
          this.$toast.success(`Scheduled job '${job.name}' has been ${newStatus ? 'enabled' : 'disabled'}.`);
        } else {
          this.$toast.error(response.data.message);
          // Revert the toggle on failure
          job.is_active = !newStatus;
        }
      })
      .catch(() => {
        this.$toast.error('An error occurred while updating the job status.');
        // Revert the toggle on failure
        job.is_active = !newStatus;
      });
    },

    onRun(){
      this.loading = true;
      let data = {
        name: this.selectedItem.scheduled_job.name
      }

      if (!this.selectedOrg) {
        this.loading = false;
        return
      }

      this.$axios.post(`/supadmin/scheduled-jobs/${this.selectedItem.scheduled_job.ID}/run/${this.selectedOrg}` +
          `?time=` + moment().local().format('HH:mm:ss') +
          `&name=` + this.$store.state.auth.jwtPayload.first_name + ` ` +
          this.$store.state.auth.jwtPayload.last_name , data)
      .then((response) => {
          if (response.data.success){
              this.$toast.success(response.data.message)
              this.loading = false;
      } else {
              this.$toast.error(response.data.message)
              this.loading = false;
          }
      })
      .catch(() => {
          this.loading = false;
      })
    },

    onRunAll(item){
      this.loading = true;
        let data = {
            name: item.scheduled_job.name
        }

        this.$axios.post(`/supadmin/scheduled-jobs/${item.scheduled_job.ID}/run`+
            `?time=` +moment().local().format('HH:mm:ss') +
            `&name=` + this.$store.state.auth.jwtPayload.first_name + ` ` +
            this.$store.state.auth.jwtPayload.last_name , data)
        .then((response) => {
            if (response.data.success){
              this.$toast.success(response.data.message)
              this.loading = false;
            } else {
              this.$toast.error(response.data.message)
              this.loading = false;
            }
        })
        .catch(() => {
            this.loading = false;
        })
    },

    getCronLogs(item){
      this.logsLoading = true
      let params = {
        limit: this.pagination.rowsPerPage,
        page: this.pagination.page
      }

      this.selectedItem = item;
      this.$axios.get(`/supadmin/scheduled-jobs/${item.scheduled_job.ID}/cron-logs`,{params})
      .then((response) => {
        if (response.data.success){
          this.pagination.total = response.data.total
          this.logs = response.data.cron_logs;
          this.filterCronLog();
        } else
          this.$toast.error(response.data.message)

        this.logsLoading = false
      })
      .catch()
    },

    filterCronLog() {
      if (this.organisations.length != 0) {
        for (let i = 0; i < this.logs.length; i++) {
          let orgIndex = this.isOrgExists(this.organisations, this.logs[i].organisation_id);
          if (orgIndex  == null)   {
              this.logs[i]["organisation"] = "All"
          } else {
              this.logs[i]["organisation"] = this.organisations[orgIndex].name
          }
        }
      }
    },

    isOrgExists(array, id) {
      for (let i = 0; i < array.length; i++) {
          if (array[i].id == id) {
              return i;
          }
      }
      return null
    },

    showOrgList(item){
      this.runDialog = true;
      this.selectedItem = item;
    },

    closeOrgList() {
      this.runDialog = false;
      this.selectedOrg = null;
      this.selectedItem = null;
    },

    utcToLocal(time) {
      //convert utc to local
      var m = moment(time)
      return m.local().format("HH:mm")
    },

    localToUTC(time) {

      //convert local time to utc
      var m = moment()

      if (time == null) {
          m.set({h: "00", m: "00"});
      }else{
          let t = time.split(":")
          m.set({h: t[0], m: t[1]});
      }

      return m.utc()
    },

    runTime(item){
     return moment(item.CreatedAt).local().format('LL hh:mm A')
    },

    onFrequencyChange(item) {
      this.schedule.frequency = item
    },


    //schedules
    getSchedules(id){
      this.loading = true;

      this.$axios.get(`/supadmin/scheduled-jobs/${id}/schedules`)
      .then((response) => {
          if (response.data.success){
              this.schedules = response.data.job_schedules;
          } else {
              this.$toast.error(response.data.message)
          }
          this.loading = false;
      })
      .catch()
    },

    saveSchedule(){
      this.v$.schedule.email.$touch();
      this.v$.schedule.frequency.$touch();
      this.v$.schedule.time.$touch();
      if (this.v$.schedule.email.$invalid || this.v$.schedule.frequency.$invalid || this.v$.schedule.time.$invalid) return

      this.loading = true;
      this.schedule.time = this.localToUTC(this.schedule.time.hours + ":" + this.schedule.time.minutes)

      let data = {
          scheduled_job_id: this.selectedItem.scheduled_job.ID,
          frequency: this.schedule.frequency,
          time: this.schedule.time.format(),
          email: this.schedule.email,
          success_alerts: this.schedule.successAlerts,
          fail_alerts: this.schedule.failAlerts
      }

      if (this.saveButton == "Save"){
          this.$axios.post(`/supadmin/job-schedule`, data)
          .then((response) => {
              if (response.data.success){
                  this.$toast.success(response.data.message);
                  this.getSchedules(this.selectedItem.scheduled_job.ID);
                  this.getData();

                  this.clearSchedule();
              } else {
                  this.$toast.error(response.data.message)
              }
              this.loading = false;
          })
          .catch()
      } else {
          this.$axios.put(`/supadmin/job-schedule/${this.schedule.id}`, data)
          .then((response) => {
              if (response.data.success){
                  this.$toast.success(response.data.message);
                  this.getSchedules(this.selectedItem.scheduled_job.ID);
                  this.getData();
                  this.clearSchedule();
              } else {
                  this.$toast.error(response.data.message)
              }
            this.loading = false;
          })
          .catch()
      }
    },

    showSaveUpdateResponse(response){
      if (response.data.success){
          this.$toast(response.data.message)

          this.getData();

          this.risk = '';
          this.buttonSave = 'save';
          this.scheduledJobDialog = false;
          this.$refs.scheduleForm.reset();
      } else {
        this.$toast(response.data.message)
      }
    },

    deleteSchedule(item){
      if(confirm("Do you really want to delete this schedule?")) {
          this.$axios.delete(`/supadmin/job-schedule/${item.ID}`)
          .then((response) => {
              if (response.data.success){
                  this.$toast.success(response.data.message);
                  this.getSchedules(this.selectedItem.scheduled_job.ID);
                  this.getData();
              } else {
                  this.$toast.error(response.data.message);
              }
          })
          .catch()
      }
    },

    showSchedule(item){
      this.scheduleDialog = true;
      this.selectedItem = item;
      this.getSchedules(item.scheduled_job.ID);
    },

    clearSchedule() {
      this.schedule.id = null;
      this.schedule.email = "";
      this.schedule.time = this.time;
      this.schedule.frequency = '';
      this.schedule.successAlerts  = false;
      this.schedule.failAlerts  = false;
      this.saveButton = "Save";
      this.v$.$reset();
    },

    editSchedule(item){
      this.schedule.id = item.ID;
      this.schedule.email = item.email;
      this.schedule.frequency = item.frequency;
      this.schedule.successAlerts = item.success_alerts;
      this.schedule.failAlerts = item.fail_alerts;
      this.saveButton = "Update";
      let time = moment(item.time);
      this.schedule.time = {
        hours: time.hour(),
        minutes: time.minutes()
      }
    },

    prev(item){
      if (this.logsLoading) return

      this.logsExpanded = item
      this.pagination.page > 1 ? this.pagination.page -= 1 : ''
    },

    next(item) {
      if (this.logsLoading) return

      this.logsExpanded = item
      this.logs.length >= this.pagination.rowsPerPage ? this.pagination.page += 1 : ''
    },

    navItemCollapse(sortedIndex) {
      const originalIndex = this.jobs.indexOf(this.sortedJobs[sortedIndex]);
      const expandedItem = this.jobs[originalIndex];

      this.jobs = this.jobs.map((item, i) => {
        item.expand = i === originalIndex ? !item.expand : false;
        return item;
      });

      // Set the expanded log for the current expanded item
      this.expandedLog = expandedItem;

      // Set the active log
      this.setActiveLog(expandedItem, originalIndex);
    },

    setActiveLog(item, index){
      if (this.expandedIndex != index){
        this.pagination.page = 1
        this.expandedIndex = index
      }

      if (this.expandedLog.expand)
        this.getCronLogs(item)
    },

    filterOrgs(e) {
      const { organisations } = this;
      e = e || window.event;
      var target = e.target || e.srcElement;

      this.filteredOrgs =  organisations.filter(({ name }) => name.toLowerCase().includes(target.value.toLowerCase()));
    },

    sortList() {
      this.pagination.sortBy.value = (this.pagination.sortBy.value === "ascending") ? "descending" : "ascending";
    },

    extractTime(schedule) {
      // Check if schedule exists before attempting to split and trim
      if (schedule) {
        // Split the schedule and get the time part
        const timePart = schedule.split("|")[0].split("-")[1].trim();
        return timePart;
      } else {
        // Return a default value or handle the case where schedule is undefined
        return null;
      }
    },
  },

  computed: {
    currPage(){
      return this.pagination.page
    },

    paginationLabel() {
      var start =  Math.min((this.pagination.page - 1) * this.pagination.rowsPerPage + 1, this.pagination.total);
      var end = Math.min((this.pagination.page * this.pagination.rowsPerPage), this.pagination.total)

      return start + " - " + end
    },

    rows() {
      return this.pagination.rowsPerPage
    },

    sortedJobs() {
      const indices = Array.from(Array(this.jobs.length).keys());

      if (this.pagination.sortBy.value === 'ascending' || this.pagination.sortBy.value === 'descending') {
        const sortedIndices = indices.sort((a, b) => {
          const timeA = this.extractTime(this.jobs[a].schedule);
          const timeB = this.extractTime(this.jobs[b].schedule);

          if (timeA === null && timeB === null) {
            return 0;
          } else if (timeA === null) {
            return 1;
          } else if (timeB === null) {
            return -1;
          }

          const comparisonResult = this.pagination.sortBy.value === 'ascending'
            ? timeA.localeCompare(timeB)
            : timeB.localeCompare(timeA);

          return comparisonResult;
        });

        return sortedIndices.map((index) => this.jobs[index]);
      } else {
        // If sortBy.value is not 'ascending' or 'descending', return the original array unsorted
        return this.jobs.slice();
      }
    },



  },

  watch: {
    currPage(){
      this.getCronLogs(this.expandedLog)
    },

    rows() {
      this.pagination.page = 1
      this.getCronLogs(this.jobs[this.expandedIndex])
    }
  }

};

</script>

<style scoped>
/* Custom slider styles from ArchiveSwitch.vue */
.custom-slider {
  position: relative;
  width: 42px;
  height: 22px;
  margin-right: 5px;
  display: inline-block;
  vertical-align: middle;
}

.custom-slider .slider {
  position: absolute;
  top: 1px;
  left: 1px;
  width: 40px;
  height: 20px;
  background-color: #bebebe; /* Grey for unchecked/inactive (Archived) */
  border-radius: 11px;
  cursor: pointer;
  transition: 0.4s;
}

.custom-slider .slider-button {
  position: absolute;
  top: 0px;
  left: 1px;
  width: 20px;
  height: 20px;
  background-color: grey; /* Grey for unchecked/inactive (Archived) */
  border-radius: 50%;
  transition: 0.4s;
}

.custom-slider .form-check-input:checked + .slider {
  background-color: #B5DAC6; /* Light green for active */
}

.custom-slider .form-check-input:checked + .slider .slider-button {
  transform: translateX(20px);
  background-color: #00B972; /* Green color for checked/active */
}

/* 🚨 FIX: Only hide the input if it's inside the custom slider! */
.custom-slider .form-check-input {
  opacity: 0;
  width: 0;
  height: 0;
}

  .table th {
    background:#F5F5F5;
    color:#435666;
  }

  .table tr td {
    color:#435666;
  }

  .expand tr td {
    border-top: none !important;
    border-bottom: none !important;
    font-size:14px;
  }

  .btn-log[aria-expanded=false] .log-expanded {
  display: none;
  }

  .btn-log[aria-expanded=true] .log-collapsed {
    display: none;
  }

.text-default{
	color: #435666;
}

.vue-select {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    border-radius: 4px;
    border: 1px solid #999;
    box-sizing: border-box;
    outline: 0;
}
</style>


<style scoped>
:deep(.modal-container) {
  display: flex;
  justify-content: center;
  align-items: center;
}

:deep(.modal-content) {
  max-height: 90%;
  width: 30%;
}

:deep(.modal-content-schedule) {
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 90%;
  border-radius: 10px;
  background: #fff;
  width: 40%;
}
.modal__title {
  margin: 0 2rem 0 0;
  font-size: 1.2rem;
  font-weight: 700;
}

.modal__content {
  overflow-y:visible;
}

.modal__body {
  overflow-y: visible;
}

.modal__content-schedule {
  flex-grow: 1;
  overflow:hidden;
  overflow-y:auto;
}
.modal__action {
  display: flex;
  justify-content: space-between;
  flex-shrink: 0;
  padding: 1rem 0 0;
}

@media screen and (max-width: 900px) {

:deep(.modal-content-schedule) {
  width: 95%;
}

:deep(.modal-content) {
  width: 95%;
}
}
</style>